import React, { ReactElement, useEffect, useRef, useState } from 'react';
import styles from './Facilities.module.scss'
import { useOrientations } from "@common/hooks/useOrientation";
import { MobileList } from "@kursk/components/pages/SingleHotel/Facilities/MobileList";
import {
  AnimalsIcon, ArrowDownIcon,
  AvailabilityIcon, BusinessIcon, ChildrenIcon, EntertainmentIcon,
  GeneralIcon, HealthAndBeautyIcon,
  InRoomIcon, InternetIcon,
  NutritionIcon, ParkingIcon, SanitaryMeasuresIcon, TourismIcon,
  ServicesAndAmenitiesIcon, SportIcon, WinterSportIcon, TheStaffSaysIcon, TransferIcon
} from "@kursk/components/ui/icons";
import classNames from "classnames";
import { IFacility } from "@common/redux/types/places";

interface IProp {
  facilities: IFacility[];
}

const icons = {
  GeneralIcon: () => <GeneralIcon/>,
  InRoomIcon: () => <InRoomIcon/>,
  AvailabilityIcon: () => <AvailabilityIcon/>,
  ServicesAndAmenitiesIcon: () => <ServicesAndAmenitiesIcon/>,
  NutritionIcon: () => <NutritionIcon/>,
  InternetIcon: () => <InternetIcon/>,
  TransferIcon: () => <TransferIcon/>,
  TheStaffSaysIcon: () => <TheStaffSaysIcon/>,
  TourismIcon: () => <TourismIcon/>,
  EntertainmentIcon: () => <EntertainmentIcon/>,
  ParkingIcon: () => <ParkingIcon/>,
  BusinessIcon: () => <BusinessIcon/>,
  SportIcon: () => <SportIcon/>,
  HealthAndBeautyIcon: () => <HealthAndBeautyIcon/>,
  ChildrenIcon: () => <ChildrenIcon/>,
  AnimalsIcon: () => <AnimalsIcon/>,
  WinterSportIcon: () => <WinterSportIcon/>,
  SanitaryMeasuresIcon: () => <SanitaryMeasuresIcon/>
};

const iconsMap = new Map([
  ['Общее', icons.GeneralIcon()],
  ['В номерах', icons.InRoomIcon()],
  ['Доступность', icons.AvailabilityIcon()],
  ['Услуги и удобства', icons.ServicesAndAmenitiesIcon()],
  ['Питание', icons.NutritionIcon()],
  ['Интернет', icons.InternetIcon()],
  ['Трансфер', icons.TransferIcon()],
  ['Персонал говорит', icons.TheStaffSaysIcon()],
  ['Туризм', icons.TourismIcon()],
  ['Развлечения', icons.EntertainmentIcon()],
  ['Парковка', icons.ParkingIcon()],
  ['Бизнес', icons.BusinessIcon()],
  ['Спорт', icons.SportIcon()],
  ['Красота и здоровье', icons.HealthAndBeautyIcon()],
  ['Дети', icons.ChildrenIcon()],
  ['Животные', icons.AnimalsIcon()],
  ['Зимние виды спорта', icons.WinterSportIcon()],
  ['Санитарные меры', icons.SanitaryMeasuresIcon()],
])

export function Facilities({ facilities }: IProp): ReactElement {
  const orientation = useOrientations();
  const ref = useRef(null)
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    return setIsShow(orientation === 'tablet' && ref.current.clientHeight > 1100)
  }, [orientation, ref]);
  const toggle = () => {
    setIsShow(!isShow);
  };

  return (
    <>
      <div ref={ref} className={classNames((isShow && orientation === 'tablet') && styles.showMore)}>
        <div className={styles.facilities_title}>услуги и удобства</div>
        <ul className={styles.facilities_list}>
          {facilities.map((item, index) => {
            return (
              <li className={styles.facilities_item} key={index}>
                {orientation === 'mobile' ? (
                  <MobileList
                    icon={iconsMap.get(item.group)}
                    key={index}
                    className={styles.facilities_dropdown}
                    title={item.group}
                    items={item.facilities}
                  />
                ) : (
                  <>
                    <div className={styles.facilities_itemTitle}>{iconsMap.get(item.group)} {item.group}</div>
                    <ul className={styles.facilities_subList}>
                      {item.facilities.map((item, index) => (
                        <li className={styles.facilities_subItem} key={index}>{item}</li>
                      ))}
                    </ul>
                  </>
                )}
              </li>
            )
          })}
        </ul>
      </div>
      {orientation === 'tablet' &&
          <>
            <hr className={styles.showMoreLine}/>
            <div className={styles.showMoreBlock} onClick={toggle}>
              {isShow ? (
                <span>Посмотреть еще</span>
              ) : (
                <span>Свернуть</span>
              )}
              <span className={classNames(!isShow && styles.rotate)}><ArrowDownIcon /></span>
            </div>
          </>
      }
    </>
  );
}
